import payment from '@/api/payments'
import kpayment from '@/api/kpayment'

export const getPaymentStatusAPI = ({ commit }) => {
  payment.getPaymentStatus(result => {
    commit('setPaymentStatus', result.data.data)
  })
}

export const getPaymentOmiseAPI = ({ commit }) => {
  return new Promise((resolve, reject) => {
    payment.getOmise(result => {
      commit('setPaymentOmise', result.data.data)
      resolve(result.data.data)
    })
  })
}

export const setPaymentOmiseKeyAPI = ({ commit, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    payment.setOmiseKey(result => {
      dispatch('getPaymentOmiseAPI', '')
      resolve(result)
    }, param)
  })
}

export const getPaymentPaypalAPI = ({ commit }) => {
  return new Promise((resolve, reject) => {
    payment.getPaypal(result => {
      commit('setPaymentPaypal', result.data.data)
      resolve(result.data.data)
    })
  })
}

export const getKpaymentAPI = ({ commit }, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let result = await kpayment.getKpayment()

      commit('setKpayment', result.data.data)
      resolve(result.data.data)
    } catch (e) {
      reject(e)
    }
  })
}

export const updateKpaymentAPI = ({ commit }, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let result = await kpayment.updateKpayment(params)

      resolve(result.data)
    } catch (e) {
      reject(e)
    }
  })
}

export const setPaymentPaypalKeyAPI = ({ commit, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    payment.setPaypalKey(result => {
      dispatch('getPaymentPaypalAPI', '')
      resolve(result)
    }, param)
  })
}

export const getPaymentCurrenciesAPI = ({ commit }, param) => {
  payment.getPaymentCurrencies(result => {
    if (param === 'omise') {
      commit('setPaymentOmiseCurrencies', result.data.data)
    }
    if (param === 'paypal') {
      commit('setPaymentPaypalCurrencies', result.data.data)
    }
  }, param)
}

export const getCheckPaymentCurrencyAPI = ({ commit }, param) => {
  payment.getCheckPaymentCurrency(result => {
    commit('setCheckPaymentCurrency', result.data.data)
  }, param)
}

export const updatePaymentStatusAPI = ({ commit, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    payment.updatePaymentStatus(result => {
      dispatch('getPaymentListsAPI', '')
      resolve(result.data)
    }, param)
  })
}

export const getPaymentListsAPI = ({ commit }) => {
  return new Promise((resolve, reject) => {
    payment.getPaymentLists(result => {
      commit('setPaymentLists', result.data.data.payments)
      resolve(result.data.data.payments)
    })
  })
}

export const setPaymentSortAPI = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    commit('setPaymentLists', param)
    payment.setPaymentSort(result => {
      resolve(result.data.status)
    }, param)
  })
}

export const setPaymentAPI = ({ commit, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    payment.setPayment(result => {
      dispatch('getPaymentPaypalAPI', '')
      resolve(result)
    }, param)
  })
}

export const getPaymentCustomAPI = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    payment.getPaymentCustom(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const addPaymentAPI = ({ commit, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    payment.addPayment(result => {
      dispatch('getPaymentListsAPI', '')
      resolve(result)
    }, param)
  })
}

export const deletePaymentFieldAPI = ({ commit, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    payment.deletePaymentField(result => {
      dispatch('getPaymentListsAPI', '')
      resolve(result)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/actions.js